/** @jsxImportSource ../../i18n */
import React from 'react';
import { Check } from 'lucide-react';
import { Logo } from '../ui';

const FEATURES = [
  'Votre PEA suivi en temps réel, ligne par ligne',
  'Un rapport chaque matin, débattu par un panel d’experts IA',
  'Gladys, votre assistante, pour chaque question',
];

export const AuthLayout = ({ children }) => (
  <div className="flex min-h-screen">
    <aside className="relative hidden w-[46%] max-w-[760px] flex-col justify-between overflow-hidden border-r border-line bg-surface-1 p-12 lg:flex xl:p-16">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-[radial-gradient(720px_440px_at_12%_8%,rgb(var(--c-gold-500)/0.14),transparent_65%),radial-gradient(620px_420px_at_92%_100%,rgb(var(--c-gold-500)/0.06),transparent_60%)]" />
      <svg aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.08] [-webkit-mask-image:radial-gradient(ellipse_at_25%_15%,black,transparent_72%)] [mask-image:radial-gradient(ellipse_at_25%_15%,black,transparent_72%)]">
        <defs>
          <pattern id="auth-grid" width="56" height="56" patternUnits="userSpaceOnUse">
            <path d="M56 0H0V56" fill="none" strokeWidth="0.75" style={{ stroke: 'rgb(var(--c-gold-500))' }} />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#auth-grid)" />
      </svg>

      <Logo className="relative" />

      <div className="relative max-w-lg">
        <p className="eyebrow text-gold-400/90">Gestion de patrimoine PEA</p>
        <h1 className="mt-5 font-display text-[2.75rem] font-normal leading-[1.08] tracking-[-0.02em] text-fg xl:text-[3.25rem]">
          Votre patrimoine,
          <br />
          en toute <span className="text-gold-300">clarté</span>.
        </h1>
        <p className="mt-6 max-w-md text-[17px] leading-relaxed text-fg-muted">
          Suivez votre PEA, comprenez chaque mouvement et décidez avec l’appui d’analyses indépendantes.
        </p>
        <ul className="mt-10 space-y-4">
          {FEATURES.map((feature) => (
            <li key={feature} className="flex items-start gap-3 text-[15px] text-fg-body">
              <span aria-hidden="true" className="mt-0.5 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border border-gold-500/40 text-gold-300">
                <Check size={12} strokeWidth={2.5} />
              </span>
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <p className="relative text-xs leading-relaxed text-fg-subtle">
        Analyses fournies à titre informatif, sans valeur de conseil en investissement.
      </p>
    </aside>

    <main className="flex flex-1 items-center justify-center px-5 py-12 sm:px-8">
      <div className="w-full max-w-[420px] animate-fade-in">
        <Logo className="mb-10 lg:hidden" />
        {children}
      </div>
    </main>
  </div>
);
